module.exports = __webpack_public_path__ + "media/img/logos/2023/horizontal/halloween-6502051e58473d31256e37b0811f0617.svg";